import { useMutation } from 'react-query';

import { getAiSubTaskMitigation as mutationFn } from 'api/endPoints/getAiSubTaskMitigation';

export const useMutationGenerateSubTaskMitigation = () => {
    return useMutation<
        {
            mitigation: string;
            taskId: number;
        },
        QueryError,
        {
            taskId: number;
            laneId: string | number;
            isVirtual: boolean;
            cardId: number | null;
            versionId: number;
        }
    >((params) => mutationFn(params));
};
